import { map, includes, get, filter } from "lodash";
import { fetchPost } from "../api/fetch";
import images from "../assets/img/images";
import { LPR, OCR } from "../constants/common";

export const unknownProfiles = [
  "00000000-0000-0000-0000-000000000000",
  "00000000-0000-0000-0000-000000000001",
  "00000000-0000-0000-0000-000000000002",
  "00000000-0000-0000-0000-000000000003",
  "00000000-0000-0000-0000-000000000004",
  "00000000-0000-0000-0000-000000000005",
];

export const isUnknownProfile = (id) => {
  return unknownProfiles.includes(id);
};

export const getAttributeName = (profile, id, language) => {
  let res = "";
  if (profile && profile.attributes) {
    res = profile.attributes
      .filter((attr) => attr.id === id)
      .map((attr) => attr[`name_${language}`])[0];
  }
  return res;
};

export const getAttributeType = (profile, id) => {
  let res = "";
  if (profile && profile.attributes) {
    res = profile.attributes
      .filter((attr) => attr.id === id)
      .map((attr) => attr.data_type)[0];
  }
  return res;
};

export const getAttributeValue = (profile, id, lov, language = "en") => {
  let res = "";
  if (profile && profile.attributes) {
    res = profile.attributes
      .filter((attr) => attr.id === id)
      .map((attr) => attr.value)[0];
  }
  if (lov && res) {
    if (lov[id] && lov[id].length > 0) {
      res = lov[id]
        .filter((v) => v.id === res)
        .map((v) => v["name_" + language])[0];
    }
  }
  return res;
};

export const getAttributeValues = (profile, id, lov, language = "en") => {
  let res = [];
  if (profile) {
    if (profile.attributes) {
      res = profile.attributes.filter((attr) => attr.id === id);
      res.forEach((item) => {
        if (item.picklist) {
          item.picklist.value = item.picklist["name_" + language];
        }
      });
    }
    if (id === "tag" && profile.tag) {
      res = [{ ...profile.tag, value: profile.tag.id }];
    }
    if (res) {
      if (lov) {
        if (lov[id] && lov[id].length > 0) {
          res.forEach((item) => {
            item.displayValue = lov[id]
              .filter((v) => v.id === item.value)
              .map((v) => v["name_" + language])[0];
          });
        }
      } else {
        res = res.map((item) => ({ ...item, displayValue: item.value }));
      }
    }
  }
  return res;
};

export const getLovValue = (attrId, attrValue, lov, language = "en") => {
  let res = "";
  if (lov[attrId]) {
    res = lov[attrId]
      .filter((v) => v.id === attrValue)
      .map((v) => v["name_" + language])[0];
  }
  return res;
};

export const cloneCleanAttributes = (
  profileType,
  attributes,
  profileAttributes
) => {
  let newAttributes = [];
  let set50 = new Set();
  let pAttr = map(profileAttributes, (attr) => attr.id);
  attributes.forEach((attr) => {
    if (profileType === 1) {
      if (
        [
          31,
          32,
          33,
          34,
          35,
          41,
          20,
          23,
          26,
          24,
          27,
          39,
          36,
          37,
          38,
          19,
          50,
          195,
          207
        ].includes(attr.id)
      ) {
        if (attr.value) {
          if (attr.attributes) {
            newAttributes.push({
              id: attr.id,
              value: attr.value,
              attributes: [...attr.attributes],
            });
          } else {
            newAttributes.push({ id: attr.id, value: attr.value });
          }
        }
      }
    } else if ([2, 3].includes(profileType)) {
      if (
        [18, 42, 53, 89, 44, 45, 46, 50, 51, 52, 47, 104, 19].includes(attr.id)
      ) {
        if (attr.value) {
          if (attr.id !== 50 || !set50.has(attr.value)) {
            if (attr.attributes) {
              newAttributes.push({
                id: attr.id,
                value: attr.value,
                attributes: [...attr.attributes],
                mandatory_match: attr.mandatory_match,
              });
            } else {
              newAttributes.push({ id: attr.id, value: attr.value });
            }
            if (attr.id === 50) set50.add(attr.value);
          }
        }
      }
    } else {
      if (includes(pAttr, attr.id) && attr.value) {
        if (attr.attributes) {
          newAttributes.push({
            id: attr.id,
            value: attr.value,
            attributes: [...attr.attributes],
            mandatory_match: attr.mandatory_match,
          });
        } else {
          newAttributes.push({ id: attr.id, value: attr.value });
        }
      }
    }
  });
  return newAttributes;
};

export const getEmptyProfile = (type) => {
  let profile = {
    profile_type_id: type,
    active: true,
    sys_tag_id: "",
    attributes: [],
    images: [],
  };
  if (type === 2 || type === 3) {
    profile.attributes.push({ id: 18, value: "" });
    profile.attributes.push({ id: type === 2 ? 42 : 53, value: "" });
    profile.attributes.push({ id: 89, value: "" });
    profile.attributes.push({ id: 44, value: "" });
  }
  if (type === 1) {
    profile.attributes.push({ id: 31, value: "" });
    profile.attributes.push({ id: 32, value: "" });
    profile.attributes.push({ id: 33, value: "" });
    profile.attributes.push({ id: 34, value: "" });
    profile.attributes.push({ id: 35, value: "" });
  }
  return profile;
};

export const checkOverrideRecords = async (
  type,
  data,
  profileType,
  detectionId
) => {
  try {
    let newExistingRecords;
    if (type === LPR) {
      if (getAttributeValue(data, 44)) {
        let res = await fetchPost("event_groups/search/lpr", {
          lpr: getAttributeValue(data, 44),
          event_group_type_id: profileType === 2 ? 10 : 11,
        });
        if (detectionId) {
          res.records = res.records.filter(
            (r) => r.detection_event_group_id !== detectionId
          );
          res.count = res.records.length;
        }
        newExistingRecords = {
          count: res.count,
          records: res.records,
        };
      } else {
        newExistingRecords = {
          count: 0,
          records: [],
        };
      }
    } else if (type === OCR) {
      let body = {
        ocr: [],
        event_group_type_id: profileType === 2 ? 10 : 11,
      };
      getAttributeValues(data, 50).forEach((ocr) => {
        if (ocr.value && ocr.mandatory_match) {
          body.ocr.push({
            ocr: ocr.value,
            //type: ocr.type
          });
        }
      });
      if (body.ocr.length > 0) {
        let res = await fetchPost("event_groups/search/ocr", body);
        if (detectionId) {
          res.records = res.records.filter(
            (r) => r.detection_event_group_id !== detectionId
          );
          res.count = res.records.length;
        }
        newExistingRecords = {
          count: res.count,
          records: res.records,
        };
      } else {
        newExistingRecords = {
          count: 0,
          records: [],
        };
      }
    }
    return newExistingRecords;
  } catch (e) {
    console.log(e);
  }
};

export const processTotalRecords = (newExistingRecords) => {
  let res = [];
  let ids = new Set();
  let detectionIds = new Set();
  newExistingRecords[LPR].records.forEach((rec) => {
    if (!ids.has(rec.id) || !detectionIds.has(rec.detection_event_group_id)) {
      ids.add(rec.id);
      detectionIds.add(rec.detection_event_group_id);
      res.push(rec);
    }
  });
  newExistingRecords[OCR].records.forEach((rec) => {
    if (!ids.has(rec.id) || !detectionIds.has(rec.detection_event_group_id)) {
      ids.add(rec.id);
      detectionIds.add(rec.detection_event_group_id);
      res.push(rec);
    }
  });
  return {
    ...newExistingRecords,
    total: {
      count: res.length,
      records: res,
    },
  };
};

export const getProfileImage = (profile, allowAnyImage = false) => {
  if (get(profile, ["type", "id"]) === 1) {
    let indexedImage = get(
      filter(
        get(profile, ["images"]),
        (img) => img.active && img.enrollment_status
      ),
      [0, "url"]
    );
    if (indexedImage || !allowAnyImage) {
      return indexedImage;
    } else {
      return get(
        filter(get(profile, ["images"]), (img) => img.active),
        [0, "url"]
      );
    }
  }
  return get(
    filter(get(profile, ["images"]), (img) => img.active),
    [0, "url"]
  );
};

export const getProfileTypeIcon = (profileType) => {
  if (profileType === 1) {
    return images.humanIconBlack;
  }
  if (profileType === 2) {
    return images.truckIconBlack;
  }
  if (profileType === 3) {
    return images.trailerIconBlack;
  }
  if (profileType === 4) {
    return images.containerIconBlack;
  }
  if (profileType === 5) {
    return images.paletteIconBlack;
  }
  if (profileType === 6) {
    return images.notificationIconBlack;
  }
  if (profileType === 7) {
    return images.humanIconBlack;
  }
  if (profileType === 8){
    return images.locomotiveIcon;
  }
};
